import { jsx as _jsx } from "react/jsx-runtime";
import { Children } from 'react';
import { reduceComponents } from './reduce-head';
import { HeadSideEffect } from './head-side-effect';
import { createHeadManager } from './head-manager';
export const DATA_DYNAMIC_HEAD = 'data-dynamic';
export const initHeadManager = () => {
    window.headManager = createHeadManager();
};
export const StaticHead = (props) => {
    const { children } = props;
    if (__BUILD_TARGET__ === 'server') {
        return children;
    }
    return null;
};
export const DynamicHead = (props) => {
    const { children } = props;
    if (__BUILD_TARGET__ === 'server') {
        const components = reduceComponents(Children.toArray(children));
        return components;
    }
    return (_jsx(HeadSideEffect, { reduceComponentsToState: reduceComponents, headManager: window.headManager, children: children }));
};
